import { render, staticRenderFns } from "./FormatsTable.vue?vue&type=template&id=18248772"
import script from "./FormatsTable.vue?vue&type=script&lang=ts"
export * from "./FormatsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports